import { defineMessages } from 'react-intl';

const messages = defineMessages({
  landingTitle: {
    id: 'ISx0zZ',
    defaultMessage: 'Welcome to our AI and Automation Self-Assessment!',
  },
  landingSubTitle: {
    id: '0UgAjX',
    defaultMessage:
      'Where does your organization stand in the adoption of the latest AI and Automation technologies?',
  },
  landingText1: {
    id: 'LQhrC1',
    defaultMessage:
      'The rise of automation, AI, and generative artificial intelligence (GenAI) is making a huge impact on the way organizations do business. Using natural language, Orchestrate can streamline processes, repetitive and complex tasks, including: creating a job descriptions, pulling reports, sourcing employment candidates, and more. Tasks that used to take hours can now be completed in minutes, taking your organization to the next level of automation.',
  },
  landingText2: {
    id: 'RoFg/y',
    defaultMessage:
      'Empower your employees to leverage AI and automation through natural conversation, without the need for specialised skills, such as coding or programming.',
  },
  EndingDiscoveryTitle: {
    id: '9bXFec',
    defaultMessage: 'Discovery',
  },
  EndingExperimentationTitle: {
    id: 'qYAIVj',
    defaultMessage: 'Experimentation',
  },
  EndingAdoptionTitle: {
    id: 'GglIqw',
    defaultMessage: 'Adoption',
  },
  EndingListTitle1: {
    id: 'mUt/kE',
    defaultMessage: 'Want a quick start?',
  },
  EndingListTitle2: {
    id: 'saUwmb',
    defaultMessage: 'Start with these resources',
  },
  EndingListTitle3: {
    id: 'HWtE78',
    defaultMessage: 'Ready to dive in? ',
  },
  EndingDiscoveryListLink1: {
    id: 'Gbv8VQ',
    defaultMessage: 'Watch these Demo videos',
  },
  EndingDiscoveryListLink2: {
    id: 'a+1i3M',
    defaultMessage: 'Take our Interactive demo',
  },
  EndingExperimentationListLink1: {
    id: 'G8BeWE',
    defaultMessage: 'Explore watsonx Orchestrate Integrations',
  },
  EndingExperimentationListLink2: {
    id: 'ro1nQ5',
    defaultMessage: 'Learn how others are using watsonx Orchestrate',
  },
  EndingExperimentationListLink3: {
    id: 'a+1i3M',
    defaultMessage: 'Take our Interactive demo',
  },
  EndingAdoptionListLink1: {
    id: 'YnnGsv',
    defaultMessage: 'Join our IBM Partner Program',
  },
  EndingAdoptionListLink2: {
    id: '5L7Na4',
    defaultMessage: 'Join our Automation Community',
  },
  EndingAdoptionListLink3: {
    id: '55jgmP',
    defaultMessage: 'Book a live demo with an IBM expert',
  },
  EndingDiscoveryText1: {
    id: 'p5M/38',
    defaultMessage:
      'You are starting on your AI and Automation journey. Realizing the need to get your business ready for Automation and AI to avoid the loss of competitiveness, you will need a complete picture of your environment to start moving forward with a vision.',
  },
  EndingDiscoveryText2: {
    id: '/a2Tfb',
    defaultMessage:
      'First, focus on gaining knowledge about AI and Automation and the ways in which it can help automate your business processes, repetitive tasks and increase overall productivity. Where does your team waste too much time on repetitive tasks that take away from high value (strategic, creative, personable) work?',
  },
  EndingDiscoveryText3: {
    id: 'Y6ZnI1',
    defaultMessage:
      'Then, evaluate what are the areas/departments where processes could be automated. Start with a strategy and make sure you communicate it throughout the organization. Your company must be ready for this change from the employee level and adjust processes accordingly before you bring in the technology.',
  },
  EndingExperimentationText1: {
    id: 'ZQw0YT',
    defaultMessage:
      'Your team has already started your AI and Automation journey, establishing a vision and identifying areas where you can start implementing new technologies.',
  },
  EndingExperimentationText2: {
    id: 'U9beox',
    defaultMessage:
      'You have likely already started considering the following:',
  },
  EndingExperimentationText3: {
    id: '9r8Fyp',
    defaultMessage:
      'Does your team have the relevant skills to adopt AI and Automation?',
  },
  EndingExperimentationText4: {
    id: 'MtXtjV',
    defaultMessage:
      'Is your team spending too much time with repetitive and inefficient tasks that take away from higher-value (strategic, creative, personable) work?',
  },
  EndingExperimentationText5: {
    id: 'bKEH1C',
    defaultMessage:
      'Do I need a partner that can guide me on the path to Automation and help me to overcome the challenges that come with aligning to changing technology?',
  },
  EndingExperimentationText6: {
    id: 'tUxx/B',
    defaultMessage:
      'Experimentation is an essential activity to determine the most suitable technologies for your business.',
  },
  EndingAdoptionText1: {
    id: '27q5+F',
    defaultMessage:
      'Congratulations! Your team is well under way to adopting new AI and Automation technologies, having realised the risk of loss of competitiveness if being left behind. Keeping up with the latest technological innovations is key for achieving success and maintaining a competitive edge.',
  },
  EndingAdoptionText2: {
    id: 'NbydS7',
    defaultMessage:
      'It is important to find a reliable partner- a leading innovator in AI and Automation, who can assist you in anticipating and adapting to future advancements. IBM watsonx Orchestrate, powered by LLMs, is here to help by bringing AI to every employee.',
  },
  pathSelectTitle: {
    id: 'w4lCiJ',
    defaultMessage: 'Pick your path',
  },
  path1Btn: {
    id: 'LcgygK',
    defaultMessage: 'Business: Non-Technical',
  },
  path2Btn: {
    id: 'bGBN4N',
    defaultMessage: 'IT: Technical',
  },
  page_title: {
    id: 'FIceXD',
    defaultMessage: 'AI and Automation Self-Assessment',
  },
  NonTech_1_question: {
    id: 'rymivM',
    defaultMessage:
      'What is the level of AI and automation adoption in your organization?',
  },
  NonTech_1_ans1: {
    id: 'vnZkJN',
    defaultMessage:
      'Some initial AI and automation solutions have been implemented',
  },
  NonTech_1_ans2: {
    id: 'XXj+HT',
    defaultMessage:
      'We are currently in the process of implementing the first AI or automation solution ',
  },
  NonTech_1_ans3: {
    id: 'yLBBZS',
    defaultMessage:
      'The first AI or automation solution is planned for implementation in the next 3 to 6 months',
  },
  NonTech_1_ans4: {
    id: 'Eb+3Nx',
    defaultMessage:
      "AI and automation are an integral part of my ogranization's day-to-day activities",
  },
  NonTech_1_ans5: {
    id: 'oPFcTx',
    defaultMessage: "I don't know/not applicable",
  },
  NonTech_2_question: {
    id: 'bZGnIL',
    defaultMessage:
      'When choosing AI and automation technologies for your business, what is the most important consideration?',
  },
  NonTech_2_ans1: {
    id: 'O0RhX/',
    defaultMessage: 'Ease of integration with existing systems',
  },
  NonTech_2_ans2: {
    id: '8pep6V',
    defaultMessage:
      'Increase in workforce productivity (reduce time spent on repetitive and time-consuming tasks)',
  },
  NonTech_2_ans3: {
    id: 'yA7JRY',
    defaultMessage:
      'An accessible experience for non-technical users and improved employee engagement ',
  },
  NonTech_2_ans4: {
    id: '6GcM6/',
    defaultMessage: 'Vendor reputation and level of support',
  },
  NonTech_2_ans5: {
    id: 'oPFcTx',
    defaultMessage: "I don't know/not applicable",
  },
  NonTech_3_question: {
    id: 'dQmCar',
    defaultMessage:
      'What challenges have you faced when adopting AI and automation, especially in relation to your workforce?',
  },
  NonTech_3_ans1: {
    id: '9/JfNV',
    defaultMessage: 'Skepticism from employees',
  },
  NonTech_3_ans2: {
    id: 'TVusSv',
    defaultMessage: 'Resistance from employees',
  },
  NonTech_3_ans3: {
    id: 'FL2ojw',
    defaultMessage: 'Skill gaps in the existing workforce',
  },
  NonTech_3_ans4: {
    id: '0vFOcy',
    defaultMessage: 'Two or more of the above',
  },
  NonTech_3_ans5: {
    id: 'oPFcTx',
    defaultMessage: "I don't know/not applicable",
  },
  NonTech_4_question: {
    id: 'rJyQM/',
    defaultMessage:
      'How do you assess the impact of AI and automation on your workforce?',
  },
  NonTech_4_ans1: {
    id: 'yyIgnm',
    defaultMessage: 'Through regular surveys and feedback sessions',
  },
  NonTech_4_ans2: {
    id: 'S2shEa',
    defaultMessage: 'Through key performance indicators (KPIs) tracking',
  },
  NonTech_4_ans3: {
    id: 'njD672',
    defaultMessage: 'Through employee engagement metrics',
  },
  NonTech_4_ans4: {
    id: '0vFOcy',
    defaultMessage: 'Two or more of the above',
  },
  NonTech_4_ans5: {
    id: 'oPFcTx',
    defaultMessage: "I don't know/not applicable",
  },
  NonTech_5_question: {
    id: 'SxxEEK',
    defaultMessage:
      'In which areas of business/organization do you expect to see the highest impact from the adoption of AI and automation? (Select all that apply)',
  },
  NonTech_5_ans1: {
    id: 'PKQphl',
    defaultMessage: 'Process optimization',
  },
  NonTech_5_ans2: {
    id: 'jawpRt',
    defaultMessage: 'Return on investment',
  },
  NonTech_5_ans3: {
    id: 'SA498F',
    defaultMessage: 'Customer experience',
  },
  NonTech_5_ans4: {
    id: '/wI5Dp',
    defaultMessage: 'Employee engagement',
  },
  NonTech_5_ans5: {
    id: 'PzJaFj',
    defaultMessage: 'Risk assessment and compliance',
  },
  NonTech_5_ans6: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  NonTech_6_question: {
    id: 'Q8QzFK',
    defaultMessage:
      'Which business processes have been automated (or planned for automation) in your organization? (Select all that apply)',
  },
  NonTech_6_ans1: {
    id: 'XQtepb',
    defaultMessage: 'HR processes',
  },
  NonTech_6_ans2: {
    id: 'uaQIUm',
    defaultMessage: 'Employee onboarding',
  },
  NonTech_6_ans3: {
    id: 'j73vKe',
    defaultMessage: 'Purchase order processing',
  },
  NonTech_6_ans4: {
    id: 'rC6jCe',
    defaultMessage: 'Customer services',
  },
  NonTech_6_ans5: {
    id: 'Nhos0o',
    defaultMessage: 'Marketing and sales processes',
  },
  NonTech_6_ans6: {
    id: 'VVbcAA',
    defaultMessage: 'Accounting and financial processes',
  },
  NonTech_6_ans7: {
    id: 'kCOgs0',
    defaultMessage: 'Data entry processing',
  },
  NonTech_6_ans8: {
    id: 'VosALA',
    defaultMessage: 'Management processes',
  },
  NonTech_6_ans9: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  NonTech_7_question: {
    id: 'AB2T3J',
    defaultMessage:
      'How would you rate the success of the implemented AI and automation in your organization?',
  },
  NonTech_7_ans1: {
    id: '81SWQK',
    defaultMessage:
      'My organization thrives with the help of AI and automation technologies',
  },
  NonTech_7_ans2: {
    id: '5YK5yB',
    defaultMessage:
      'I am pleased with the initial results following the implementation of AI and automation solutions in my organization',
  },
  NonTech_7_ans3: {
    id: 'gZMOZ9',
    defaultMessage:
      'It is too early to assess the success of the implemented AI and automation in my organization based on the level of adoption',
  },
  NonTech_7_ans4: {
    id: 'vxddrI',
    defaultMessage:
      'Following the implementation of initial AI and automation solutions in my organization, the success has been limited/ below expecations',
  },
  NonTech_7_ans5: {
    id: 'oPFcTx',
    defaultMessage: "I don't know/not applicable",
  },
  Tech_1_question: {
    id: 'bTf0Jl',
    defaultMessage:
      'What are your expectations from the adoption of AI and automation in your organization?',
  },
  Tech_1_ans1: {
    id: 'M6uZ1m',
    defaultMessage:
      'Technical support from the vendor and the availability of resources for adopting and maintaining the technology',
  },
  Tech_1_ans2: {
    id: 'r6Xdfz',
    defaultMessage: 'Seamless integration with existing technology stack',
  },
  Tech_1_ans3: {
    id: '/EvqUA',
    defaultMessage: 'Optimal level of security standards',
  },
  Tech_1_ans5: {
    id: '2eXFEc',
    defaultMessage: 'All of the above',
  },
  Tech_1_ans4: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  Tech_2_question: {
    id: '9aR794',
    defaultMessage:
      'What are your priorities when leveraging AI and automation in your organization?',
  },
  Tech_2_ans1: {
    id: '8g8jmQ',
    defaultMessage: 'Ease of integration with existing legacy systems',
  },
  Tech_2_ans2: {
    id: '8FacIk',
    defaultMessage: 'Scalability',
  },
  Tech_2_ans3: {
    id: 'Qh5vmW',
    defaultMessage: 'High level of security',
  },
  Tech_2_ans4: {
    id: 'jxaZVg',
    defaultMessage: 'Clear and transparent pricing',
  },
  Tech_2_ans5: {
    id: 'oPFcTx',
    defaultMessage: "I don't know/not applicable",
  },
  Tech_3_question: {
    id: 'dQmCar',
    defaultMessage:
      'What challenges have you faced when adopting AI and automation, especially in relation to your workforce?',
  },
  Tech_3_ans1: {
    id: '9/JfNV',
    defaultMessage: 'Skepticism from employees',
  },
  Tech_3_ans2: {
    id: 'TVusSv',
    defaultMessage: 'Resistance from employees',
  },
  Tech_3_ans3: {
    id: 'FL2ojw',
    defaultMessage: 'Skill gaps in the existing workforce',
  },
  Tech_3_ans4: {
    id: '0vFOcy',
    defaultMessage: 'Two or more of the above',
  },
  Tech_3_ans5: {
    id: 'oPFcTx',
    defaultMessage: "I don't know/not applicable",
  },
  Tech_4_question: {
    id: 'rJyQM/',
    defaultMessage:
      'How do you assess the impact of AI and automation on your workforce?',
  },
  Tech_4_ans1: {
    id: 'yyIgnm',
    defaultMessage: 'Through regular surveys and feedback sessions',
  },
  Tech_4_ans2: {
    id: 'S2shEa',
    defaultMessage: 'Through key performance indicators (KPIs) tracking',
  },
  Tech_4_ans3: {
    id: 'njD672',
    defaultMessage: 'Through employee engagement metrics',
  },
  Tech_4_ans4: {
    id: '0vFOcy',
    defaultMessage: 'Two or more of the above',
  },
  Tech_4_ans5: {
    id: 'oPFcTx',
    defaultMessage: "I don't know/not applicable",
  },
  Tech_5_question: {
    id: 'SxxEEK',
    defaultMessage:
      'In which areas of business/organization do you expect to see the highest impact from the adoption of AI and automation? (Select all that apply)',
  },
  Tech_5_ans1: {
    id: 'PKQphl',
    defaultMessage: 'Process optimization',
  },
  Tech_5_ans2: {
    id: 'jawpRt',
    defaultMessage: 'Return on investment',
  },
  Tech_5_ans3: {
    id: 'SA498F',
    defaultMessage: 'Customer experience',
  },
  Tech_5_ans4: {
    id: '/wI5Dp',
    defaultMessage: 'Employee engagement',
  },
  Tech_5_ans5: {
    id: 'PzJaFj',
    defaultMessage: 'Risk assessment and compliance',
  },
  Tech_5_ans6: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  Tech_6_question: {
    id: '/IzoXQ',
    defaultMessage:
      'What AI and automation technologies are currently in use within your organization? (Select all that apply)',
  },
  Tech_6_ans1: {
    id: 'f8F5cm',
    defaultMessage: 'Robotic process automation',
  },
  Tech_6_ans2: {
    id: 'vaobtm',
    defaultMessage: 'Workflow automation',
  },
  Tech_6_ans3: {
    id: 'hfvEQS',
    defaultMessage: 'Data entry automation',
  },
  Tech_6_ans4: {
    id: 'DA+cPT',
    defaultMessage: 'Document management automation',
  },
  Tech_6_ans5: {
    id: 'HY/U3F',
    defaultMessage: 'Task automation',
  },
  Tech_6_ans6: {
    id: '+VgkWl',
    defaultMessage: 'Process mining',
  },
  Tech_6_ans7: {
    id: 'F7ARIC',
    defaultMessage: 'Natural language processing',
  },
  Tech_6_ans8: {
    id: 'DApKt8',
    defaultMessage: 'Machine learning & AI',
  },
  Tech_6_ans9: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  Tech_7_question: {
    id: 'AB2T3J',
    defaultMessage:
      'How would you rate the success of the implemented AI and automation in your organization?',
  },
  Tech_7_ans1: {
    id: '81SWQK',
    defaultMessage:
      'My organization thrives with the help of AI and automation technologies',
  },
  Tech_7_ans2: {
    id: '5YK5yB',
    defaultMessage:
      'I am pleased with the initial results following the implementation of AI and automation solutions in my organization',
  },
  Tech_7_ans3: {
    id: 'gZMOZ9',
    defaultMessage:
      'It is too early to assess the success of the implemented AI and automation in my organization based on the level of adoption',
  },
  Tech_7_ans4: {
    id: 'vxddrI',
    defaultMessage:
      'Following the implementation of initial AI and automation solutions in my organization, the success has been limited/ below expecations',
  },
  Tech_7_ans5: {
    id: 'oPFcTx',
    defaultMessage: "I don't know/not applicable",
  },
  social: {
    id: 'OKhRC6',
    defaultMessage: 'Share',
  },
  facebook: {
    id: '06VF+w',
    defaultMessage: 'Share on Facebook',
  },
  twitter: {
    id: '80Vefc',
    defaultMessage: 'Share on Twitter',
  },
  linkedin: {
    id: 'M4kFT5',
    defaultMessage: 'Share on LinkedIn',
  },
  email: {
    id: '/ukNSg',
    defaultMessage: 'Share via Email',
  },
  welcomeMsg: {
    id: 'Q+U0TW',
    defaultMessage: 'Welcome!',
  },
  welcomeParagraph: {
    id: '7NMvOF',
    defaultMessage: 'This is a template for creating widgets.',
  },
  secondary: {
    id: 'CH/2W8',
    defaultMessage: 'MaaS360 Plan Assessment ',
  },
  landingBtn_text: {
    id: 'W3B7bp',
    defaultMessage: 'Start the assessment',
  },
  pagerResultsBtn_text: {
    id: '4jl5zC',
    defaultMessage: 'View the results',
  },
  order_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  back_text: {
    id: 'xktFGM',
    defaultMessage: 'Back to Assessment',
  },
  restart_text: {
    id: '4prk89',
    defaultMessage: 'Start over',
  },
  chat_text: {
    id: 'IjD/pk',
    defaultMessage: 'Chat with IBM',
  },
  drawer_close: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  launch_btn_text: {
    id: 'wxRIRT',
    defaultMessage: 'Launch Assessment',
  },
  que1_text_desc: {
    id: 'qxgrQW',
    defaultMessage:
      'Do you need to securely access intranet sites or corporate resources on multiple devices?',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  que2_text_desc: {
    id: '/DU1io',
    defaultMessage:
      'Do you wish to detect and remediate malware, virus, phishing and other cyberthreats on compromised devices?',
  },
  que2_short_desc: {
    id: 'XpBqtj',
    defaultMessage: 'For example: Mobile threat management.',
  },
  que3_text_desc: {
    id: '6sKLeQ',
    defaultMessage:
      'Do you have additional use case requirements for any of the below?',
  },
  que3_tooltip_text: {
    id: 'fx+gRp',
    defaultMessage:
      "TeamViewer is a third-party offering which may be purchased with our sales team's assistance.",
  },
  que3_opt1: {
    id: 'DIqNEt',
    defaultMessage:
      'TeamViewer - over-the-air OTA device views remote access and control',
  },
  que3_opt2: {
    id: 'lk6DwT',
    defaultMessage:
      'Wandera - advanced threat defenses from cyber threats and user-based risks',
  },
  que3_opt3: {
    id: 'NiVxun',
    defaultMessage: 'Additional IBM Security solutions and/or services',
  },
  que3_opt4: {
    id: 'S8OTDS',
    defaultMessage: 'No additional requirements',
  },
  que3_opt1_short_ans_selec: {
    id: '7xlzZ7',
    defaultMessage: 'TeamViewer',
  },
  que3_opt2_short_ans_selec: {
    id: 'Lrl2g2',
    defaultMessage: 'Wandera',
  },
  que3_opt3_short_ans_selec: {
    id: 'kt5tlu',
    defaultMessage: 'Extra IBM Security solutions',
  },
  que3_opt4_short_ans_selec: {
    id: 'S8OTDS',
    defaultMessage: 'No additional requirements',
  },
  que4_text_desc: {
    id: 'uZXFZU',
    defaultMessage: 'How many devices would you like to manage?',
  },
  que4_numinput_text: {
    id: 'uXGPY6',
    defaultMessage: 'Please add numbers of devices',
  },
  que4_short_desc: {
    id: 'an/uIK',
    defaultMessage:
      'Laptops, desktops, smartphones, tablet, purpose built devices?',
  },
  que4_tooltip_text: {
    id: 'G3fWHs',
    defaultMessage:
      "Your answer to this question will help the IBM MaaS360 team to provide you with the best and quickest advice, should you decide to contact IBM, and doesn't influence the result of this assessment.",
  },
  que4_opt1: {
    id: 'Htbis6',
    defaultMessage: '1-99',
  },
  que4_opt2: {
    id: 'SRC+KN',
    defaultMessage: '100-500',
  },
  que4_opt3: {
    id: 'MATDbP',
    defaultMessage: '501-1000',
  },
  que4_opt4: {
    id: 'QIAibA',
    defaultMessage: 'more than 1000',
  },
  que5_text_desc: {
    id: 'GMZGs/',
    defaultMessage: 'Which operating system(s) would you like to manage?',
  },
  que5_short_desc: {
    id: 'gSenzY',
    defaultMessage: 'Select all that apply',
  },
  que5_tooltip_text: {
    id: 'Il95Kg',
    defaultMessage:
      "Your answer to this question will help MaaS360 team provide you with the best and quickest advice, should you decide to contact IBM, and doesn't influence the result of this assessment.",
  },
  que5_opt1: {
    id: 'XnimdQ',
    defaultMessage: 'Windows',
  },
  que5_opt2: {
    id: 'edqhRc',
    defaultMessage: 'MacOS',
  },
  que5_opt3: {
    id: 'gOkLaP',
    defaultMessage: 'ChromeOS',
  },
  que5_opt4: {
    id: 'OQDKnx',
    defaultMessage: 'iOS',
  },
  que5_opt5: {
    id: 'gQ7kPU',
    defaultMessage: 'Android',
  },
  que5_opt6: {
    id: 'WGOxuS',
    defaultMessage: 'iPadOS',
  },
  que5_opt7: {
    id: '/VnDMl',
    defaultMessage: 'Other',
  },
  start_over: {
    id: 'i4joXC',
    defaultMessage: 'Start Over',
  },
  your_selection: {
    id: 'T4snp2',
    defaultMessage: 'Your Selections',
  },
  start_at: {
    id: 'Flh+ac',
    defaultMessage: 'Starting at ',
  },
  tax_info: {
    id: 'edRicU',
    defaultMessage: 'Price shown excludes any applicable taxes',
  },
  results_heading: {
    id: 'TklhEA',
    defaultMessage: '#1 pick for you',
  },
  other_results_heading: {
    id: 'NsZa5c',
    defaultMessage: 'Other recommendations',
  },
  results_button: {
    id: '6JEGxX',
    defaultMessage: 'Discover your plan',
  },
  start_trial_btn_txt: {
    id: 'FQm0Au',
    defaultMessage: 'Start your free trial',
  },
  enterprise_title: {
    id: 'thabGU',
    defaultMessage: 'MaaS360 Enterprise',
  },
  enterprise_plan: {
    id: 'AjYzeY',
    defaultMessage: 'MaaS360 Enterprise plan',
  },
  enterprise_short_desc: {
    id: '9cKiVH',
    defaultMessage:
      'The Enterprise plan is the ultimate, easy to use UEM SaaS, that addresses all your endpoint management and security needs.',
  },
  enterprise_desc: {
    id: 'i9O+Di',
    defaultMessage:
      'is a broad, easy to use UEM SaaS, that addresses your endpoint management and security needs: built-in threat management with advanced detection and response for threats such as SMS and e-mail phishing, and advanced features such as document management, content management, intranet access, application security and protected network access. MaaS360 Enterprise plan also contains capabilities such as endpoint management (mobile phones, laptops, desktops, tablets, ruggedized, purpose built), app management, automated patch management, policy and compliance rules, IAM and AI security insights (automated user risk management scoring, alerts and recommendations)',
  },
  enterprise_icon: {
    id: 'Ox+Z+K',
    defaultMessage: 'Tutorial',
  },
  essentials_title: {
    id: 'i4gdyS',
    defaultMessage: 'MaaS360 Essentials',
  },
  essentials_plan: {
    id: '5aD5Jb',
    defaultMessage: 'MaaS360 Essentials plan',
  },
  essentials_short_desc: {
    id: 'RVln+l',
    defaultMessage:
      'Manage and secure users, smartphones, tablets, laptops and apps, enabled by cognitive insights with Watson.',
  },
  essentials_desc: {
    id: 'MGhP95',
    defaultMessage:
      'covers your foundational needs of a user friendly, reliable UEM SaaS that brings together endpoint management (mobile phones, laptops, desktops, tablets, ruggedized, purpose built devices), app management, automated patch management, with cyber threat defense (policy and compliance rules, IAM) and AI security insights (automated user risk management scoring, alerts and recommendations). MaaS360 manages the following OSs: Android, iOS, iPadOS, MacOS, Windows, Chrome OS.',
  },
  essentials_icon: {
    id: 'MCIcVz',
    defaultMessage: 'Quickstart',
  },
  premier_title: {
    id: 'bNdjL4',
    defaultMessage: 'MaaS360 Premier',
  },
  premier_plan: {
    id: 'AQ6rr0',
    defaultMessage: 'MaaS360 Premier plan',
  },
  premier_short_desc: {
    id: '3Axirr',
    defaultMessage:
      'More advanced UEM and AI capabilities, plus content management, intranet access, application security and protected network access.',
  },
  premier_desc: {
    id: 'v7H2lh',
    defaultMessage:
      'addresses your more advanced needs for a UEM SaaS that should also cover content management, intranet access, application security and protected network access. The MaaS360 Premier plan also include capabilities such as endpoint management (mobile phones, laptops, desktops, tablets, ruggedized, purpose built), app management, automated patch management cyber threat defense (policy and compliance rules, IAM) and AI security insights (automated user risk management scoring, alerts and recommendations). MaaS360 manages the following OSs: Android, iOS, iPadOS, MacOS, Windows, Chrome OS.',
  },
  premier_icon: {
    id: 'tF9rgX',
    defaultMessage: 'Webinar',
  },
  deluxe_title: {
    id: 'hWv88Z',
    defaultMessage: 'MaaS360 Deluxe',
  },
  deluxe_plan: {
    id: 'HKawiR',
    defaultMessage: 'MaaS360 Deluxe plan',
  },
  deluxe_short_desc: {
    id: 'y5MCc+',
    defaultMessage:
      'Essential UEM capabilities, plus an encrypted corporate email, contacts, calendar, AI chatbot and voice assistant.',
  },
  deluxe_desc: {
    id: 'PPu6WF',
    defaultMessage:
      'covers your needs of a user friendly, reliable UEM software that ads an encrypted corporate email, contacts and calendar and AI chatbot and voice assistant to the  essential capabilities of MaaS360: endpoint management (mobile phones, laptops, desktops, tablets, ruggedized, purpose built), app management, automated patch management, cyber threat defense (policy and compliance rules, IAM) and AI security insights (automated user risk management scoring, alerts and recommendations). MaaS360 manages the following OSs:  Android, iOS, iPadOS, MacOS, Windows, Chrome OS.',
  },
  deluxe_icon: {
    id: 'Ox+Z+K',
    defaultMessage: 'Tutorial',
  },
  buy_here_btn: {
    id: 'N/Xcg3',
    defaultMessage: 'Buy here',
  },
  try_maas_btn: {
    id: 'E7ddgJ',
    defaultMessage: 'Try MaaS360 for free',
  },
  free_trial_btn_text: {
    id: 'FQm0Au',
    defaultMessage: 'Start your free trial',
  },
  back_btn: {
    id: 'cyR7Kh',
    defaultMessage: 'Back',
  },
  next_btn: {
    id: '9+Ddtu',
    defaultMessage: 'Next',
  },
  close_btn: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  consult_btn: {
    id: 'EcYmHD',
    defaultMessage: 'Schedule a Consult',
  },
  top_match: {
    id: 'KHi0ci',
    defaultMessage: 'Top Match',
  },
  thank_text: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thank_desc: {
    id: 'p9+xdw',
    defaultMessage: 'Your registration is complete.',
  },
  demo_text: {
    id: 'JVfa8m',
    defaultMessage: 'Acess interactive demo',
  },
  q1_selec_key: {
    id: 'xI64n3',
    defaultMessage: 'Securely access intranet or devices',
  },
  q2_selec_key: {
    id: 'pPhNiM',
    defaultMessage: 'Detect Malware & Cyberthreat',
  },
  q3_selec_key: {
    id: '4IfP+Z',
    defaultMessage: 'Additional use case',
  },
  q4_selec_key: {
    id: 'OlJHP9',
    defaultMessage: 'No. of devices',
  },
  q5_selec_key: {
    id: 't2uvIi',
    defaultMessage: 'Operating System',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  availableIn: {
    id: '5z8K6l',
    defaultMessage: 'The MaaS360 estimator is available in',
  },
  localCurrency_text: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  stayHere: {
    id: 'ObupdK',
    defaultMessage: 'Stay here',
  },
  ques_text: {
    id: 'kgOBET',
    defaultMessage: 'Question',
  },
  of_text: {
    id: 'C9WGEu',
    defaultMessage: 'of',
  },
  plan_buy_text: {
    id: 'ZQlA2o',
    defaultMessage: 'Please select the plan and click on buy here.',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  return_assessment: {
    id: '/YY0KV',
    defaultMessage: 'Return to assessment',
  },
  request_plan_text: {
    id: 'G5KVyN',
    defaultMessage: 'Please select the plan you would like to request a quote.',
  },
  deluxe: {
    id: 'ocaqXc',
    defaultMessage: 'Deluxe',
  },
  essentials: {
    id: 'eXbuB9',
    defaultMessage: 'Essentials',
  },
  premier: {
    id: 'sVfVAX',
    defaultMessage: 'Premier',
  },
  enterprise: {
    id: 'CDLJ0W',
    defaultMessage: 'Enterprise',
  },
});

export default messages;
